import { render } from "./DeleteMenu.vue?vue&type=template&id=448cb765"
import script from "./DeleteMenu.vue?vue&type=script&lang=js"
export * from "./DeleteMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DeleteMenu.vue"]])

export default __exports__